import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CloudIdStorageService {


  storageKey = "cloudId";

  constructor() {}

  loadCloudId() {
    return localStorage.getItem(this.storageKey);
  }

  storeCloudId(cloudId) {
    localStorage.setItem(this.storageKey, cloudId);
  }

  clear() {
    localStorage.removeItem(this.storageKey);
  }
}
